import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getYearPayment = async (an8) => {


  const token = await authHeader();

  return axios
    .get(`${ baseUrl }/bbva/year/${an8}` ,{
      headers: token 
    }
    )
    .then(response => {
      return response.data;
     }
     )
};

const getAlldetailPaymentByFilters = async (data) => {

  const url = `${ baseUrl }/anticipation/view-payment`;

  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    }
    )
    .then(response => {
      return response.data;
      }
      )
};
const downloadDetailAdvancedPaymentsXls = async(an8, data) =>{
  const token = await authHeader();
  const url = `${ baseUrl }/anticipation/excel/${an8}`

  return axios.post(url, data, {
    headers: token
  }).then((response) =>{
    return response.data
  })
}

export default {
  getAlldetailPaymentByFilters,
  getYearPayment, 
  downloadDetailAdvancedPaymentsXls
};